import React, { useState } from 'react'
import { Button, CircularProgress, Grid, IconButton, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, withStyles } from '@material-ui/core';
import { AddCircle, CloudUploadOutlined } from '@material-ui/icons';
import { green } from '@material-ui/core/colors';
import { AutomaticRows } from '../IrrigationForm/components/AutomaticRows';
import { AutomaticCurtainRows } from './components/AutomaticCurtainRows';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#3B3C43",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
buttonProgress: {
  color: green[500],
   marginLeft: 12,
},
table: {
  minWidth: 650,
  [theme.breakpoints.down('sm')]: {
    minWidth: 300,
  },
},
hideOnMobile: {
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
},
button: {
  margin: theme.spacing(1),
},
}));

export const AutomaticCurtainControl = () => {
  const classes = useStyles();
  const [dataObtainedFlag, setDataObtainedFlag] = useState(true) 
  const [rows, setRows] = useState([1,2,3])
  const [disableAutoButton, setDisableAutoButton] = useState(false)
  const matches = useMediaQuery(theme => theme.breakpoints.down('sm'));

  const addRule = () => {
    //setRuleId(prevValue => prevValue + 1 )
    console.log("Añadir Regla")
    
  }

  const handleSendButton = async () => {
    console.log("Envio de comandos MQTT")
    
  }

  return (
    <>
    {dataObtainedFlag ?
    <div style={{ marginTop: "15px" }}>
      {(matches && (rows.length !== 10)) && (
        <div style={{ marginBottom: "15px" }}>
          <Grid container justifyContent='center' alignItems='center'>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              startIcon={<AddCircle />}
              onClick={addRule}
            >
              Añadir regla
            </Button>
          </Grid>
        </div>
      )}
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell className={classes.hideOnMobile}># Regla</StyledTableCell>
              <StyledTableCell className={classes.hideOnMobile}>Cortina</StyledTableCell>
              <StyledTableCell className={classes.hideOnMobile}>Hora de apertura</StyledTableCell>
              <StyledTableCell className={classes.hideOnMobile}>Hora de cierre</StyledTableCell>
              {/* <StyledTableCell align='left' className={classes.hideOnMobile}>Activación única</StyledTableCell> */}
              {/* <StyledTableCell align='center' className={classes.hideOnMobile}>Activación múltiple</StyledTableCell> */}
              {/* <StyledTableCell align='center' className={classes.hideOnMobile}>Dias</StyledTableCell> */}
              <StyledTableCell className={classes.hideOnMobile}>
                  <IconButton key={"add_Rule"} color="primary" aria-label="add rule" component="span" onClick={addRule}>
                      <AddCircle />
                  </IconButton>
              </StyledTableCell>
              
            </TableRow>
          </TableHead>

          <TableBody>
          {rows?.map((rowId,index) => (
            <AutomaticCurtainRows Id={index} numberOfRule={rowId} />
          ))} 

          </TableBody>

        </Table>
      </TableContainer>
    </div>
    :
    <div style={{ textAlign: 'center', width: '100%', marginTop:"10px" }}>
      <h5>Cargando...</h5>
    </div>
    }

    <div style={{ marginTop: "35px", marginBottom: "10px" }}>
      <Grid container justifyContent='center' alignContent='center'>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          className={classes.button}
          disabled={rows.length === 0}
          // disabled={disableAutoButton || startHour === "" || pumpsSelected.length === 0 || 
          //   zonesSelected.length === 0 || daysOfWeek.length === 0 || (minutos === 0 && segundos === 0)
          // }
          startIcon={<CloudUploadOutlined />}
          onClick={handleSendButton}
        >
          Subir
          {disableAutoButton && <CircularProgress size={30} className={classes.buttonProgress} />}
        </Button>
        

      </Grid>
      
    </div>
    </>
  )
}
